namespace SaDateTimeUtils {
    export const TIME_REGEX = /^(\d{2}):(\d{2})/;

    export const TIME_ZONE_COOKIE_NAME = "sa_timeZone";

    export function getUserTimeZone(): string | null {
        return SaCookies.getCookie(TIME_ZONE_COOKIE_NAME);
    }

    export function setUserTimeZoneIfNotExists(): string | null {
        const value = SaCookies.getCookie(TIME_ZONE_COOKIE_NAME);
        if (!value) {
            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            // Set the time zone cookie for a day
            return SaCookies.setCookie(TIME_ZONE_COOKIE_NAME, timeZone, 1);
        }

        return value;
    }

    export function toTimeString(decimal: number, isEnd?: boolean): string {
        if (isEnd && decimal === 24) {
            return "11:59 PM";
        }

        let hours = Math.floor(decimal);
        const minutes = Math.round((decimal % 1) * 60);
        const ampm = hours >= 12 ? "PM" : "AM";

        if (hours === 0) {
            hours = 12;
        } else if (hours > 12) {
            hours -= 12;
        }

        const minutesStr = minutes.toString().padStart(2, "0");
        return `${hours}:${minutesStr} ${ampm}`;
    }

    export function to24HourString(time12h: string): string | null {
        if (!time12h) return null;

        const match = /^(\d{1,2}):(\d{2})\s*(AM|PM)$/i.exec(time12h.trim());
        if (!match?.[1] || !match?.[2] || !match?.[3]) return null;

        let hours = Number.parseInt(match[1]);
        const minutes = match[2];
        const period = match[3].toUpperCase();

        if (period === "PM" && hours !== 12) hours += 12;
        if (period === "AM" && hours === 12) hours = 0;

        return `${String(hours).padStart(2, "0")}:${minutes}:00`;
    }

    export function timeStringToDecimal(timeString: string): number {
        if (!timeString) return 0;
        const parts = timeString.split(":").map(Number);
        const hours = parts[0] || 0;
        const minutes = parts[1] || 0;
        return hours + minutes / 60;
    }
}

globalThis.SaDateTimeUtils = SaDateTimeUtils;
